
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import {AppRedirect} from '@modules/husleie-framework/src/enums/AppRedirect.enum';
import RedirectOperations from '@modules/husleie-framework/src/static-classes/RedirectOperations.class';
import {AppApiError, AppRoleEnum} from '@modules/husleie-framework/src/types/App.entity';
import i18nCommon from '@modules/i18n/mixins/Common';
import Vue, {VueConstructor} from 'vue';
import {mapGetters} from 'vuex';

export default (Vue as VueConstructor<Vue & InstanceType<typeof i18nCommon>>).extend({
  name: 'apiErrorModal',

  components: {
    'hl-Modal': Modal,
  },

  mixins: [i18nCommon],

  props: {
    errorStatus: {
      type: Object as () => AppApiError,
    },
  },
  computed: {
    ...mapGetters('common/features', ['getFeature']),

    apiErrorDetected(): boolean {
      return this.errorStatus?.error;
    },
    apiErrorTitle(): string {
      return this.capitalizeFirst(this.translate('apiWarning.modal.title'));
    },
    apiErrorText(): string {
      return this.capitalizeFirst(this.translate('apiWarning.modal.text'));
    },
    apiErrorBtnRetryLabel(): string {
      return this.capitalizeFirst(this.translate('apiWarning.modal.btn.retry'));
    },
    apiErrorBtnDashboardLabel(): string {
      return this.capitalizeFirst(this.translate('apiWarning.modal.btn.dashboard'));
    },
    apiErrorBtnHomepageLabel(): string {
      return this.capitalizeFirst(this.translate('apiWarning.modal.btn.home page'));
    },
    getDashboardUrl(): string {
      return RedirectOperations.getURL(AppRedirect.DASHBOARD_MYPAGE);
    },
    getHomepageURL(): string {
      return this.getFeature('terms.homePage.URL');
    },
    getSecondaryActionLabel(): string {
      return this.errorStatus?.role === AppRoleEnum.TENANT
        ? this.apiErrorBtnHomepageLabel
        : this.apiErrorBtnDashboardLabel;
    },
    getSecondaryActionUrl(): string {
      return this.errorStatus?.role === AppRoleEnum.TENANT ? this.getHomepageURL : this.getDashboardUrl;
    },
  },
  methods: {
    reloadWindow() {
      window.location.reload();
    },
  },
});
